module.exports = __webpack_public_path__ + "static/media/WireRope4.b85afc4c.webp";